// extracted by mini-css-extract-plugin
export var row = "ApplicationStatusBox-module__row___i92A-";
export var subtitle = "ApplicationStatusBox-module__subtitle___5xIDj";
export var title = "ApplicationStatusBox-module__title___Yy6fG";